// Décors par étage et par élément de combat.
// Les étages bouclent sur 8 thèmes, donnant une variété infinie.

export const FLOOR_THEMES = [
  { id: "forest",    name: "Forêt enchantée",   scene: "scene-forest",    accent: "🌿", particle: "🍃", particles: 8 },
  { id: "cavern",    name: "Grotte des échos",  scene: "scene-cavern",    accent: "🪨", particle: "✨", particles: 6 },
  { id: "ruins",     name: "Ruines antiques",   scene: "scene-ruins",     accent: "🏛️", particle: "🌾", particles: 6 },
  { id: "glacial",   name: "Toundra glaciale",  scene: "scene-glacial",   accent: "❄️", particle: "❄️", particles: 12 },
  { id: "volcano",   name: "Caldeira ardente",  scene: "scene-volcano",   accent: "🔥", particle: "🔥", particles: 10 },
  { id: "celestial", name: "Sanctuaire céleste", scene: "scene-celestial",accent: "🌟", particle: "✨", particles: 12 },
  { id: "astral",    name: "Plan astral",       scene: "scene-astral",    accent: "🌌", particle: "💫", particles: 14 },
  { id: "abyss",     name: "Abysse cosmique",   scene: "scene-abyss",     accent: "🕳️", particle: "🟣", particles: 10 },
];

// Décalage aléatoire par run pour varier l'ordre des biomes
let RUN_THEME_OFFSET = 0;
export const setRunThemeOffset = (offset) => {
  RUN_THEME_OFFSET = ((offset % FLOOR_THEMES.length) + FLOOR_THEMES.length) % FLOOR_THEMES.length;
};
export const getRunThemeOffset = () => RUN_THEME_OFFSET;

export const themeForFloor = (floor = 1) => {
  const idx = ((Math.max(1, floor) - 1 + RUN_THEME_OFFSET) % FLOOR_THEMES.length);
  return FLOOR_THEMES[idx];
};

// Combat backdrop combines current floor theme with the enemy element accent.
export const ELEMENT_COMBAT_CLASS = {
  feu:     "combat-feu",
  eau:     "combat-eau",
  terre:   "combat-terre",
  air:     "combat-air",
  lumiere: "combat-lumiere",
  dark:    "combat-dark",
};
